import { Component } from '@verndale/core'
import Swiper, { Navigation } from 'swiper'
import { MEDIA_QUERIES } from '../utils'

class TestimonialCarousel extends Component {
  setupDefaults() {
    this.dom = {
      sliderContainer: this.el.querySelector('.swiper'),
      slides: this.el.querySelectorAll('.testimonial-item'),
      info: this.el.querySelectorAll('.testimonial-item__info-container')
    }
    this.tallestSlide()
    if (this.dom.slides.length > 2) {
      this.initSlider()
    } else {
      this.dom.sliderContainer.classList.add('testimonial-carousel--no-slider')
    }
  }

  tallestSlide() {
    let tallestSlideHeight = 100
    this.el.style = `--tallest-info-height = ${tallestSlideHeight}px`
    this.dom.info.forEach((item) => {
      item.style.display = 'block'
      item.style.inlineSize = '60vw'
      tallestSlideHeight =
        item.offsetHeight > tallestSlideHeight ? item.offsetHeight : tallestSlideHeight
      item.style = ''
    })
    this.el.style = `--tallest-info-height: ${tallestSlideHeight}px`
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.sliderContainer, {
      modules: [Navigation],
      centeredSlides: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      loop: true,
      slidesPerView: 3,
      loopedSlides: 3,
      loopAdditionalSlides: 5,
      breakpoints: {
        // when window width is >= 360px
        [MEDIA_QUERIES.MOBILE]: {
          slidesPerView: 3,
          loopedSlides: 6
        },
        // when window width is >= 1024px
        [MEDIA_QUERIES.TABLET_LANDSCAPE]: {
          slidesPerView: this.dom.slides.length > 4 ? 5 : 3,
          loopedSlides: this.dom.slides.length > 4 ? 10 : 6
        }
      },
      on: {
        resize: () => {
          this.swiper.update()
          this.tallestSlide()
        }
      }
    })
  }
}

export default TestimonialCarousel
